import h from 'react-hyperscript';

import './Contact.css';

import Section from '../../Section';

const Hours = [
  { days: 'Monday - Thursday', hours: '9am - 5pm ET' },
  { days: 'Friday', hours: '9am - 1pm ET' },
  { days: 'Saturday - Sunday', hours: 'CLOSED' },
].map(({ days, hours }, index) => h('wrapper', [index !== 0 && h('br'), h('strong', days), ': ', hours]));

const Contact = () =>
  h(Section, { id: 'contact', className: 'contact' }, [
    h('row', {}, [
      h('.col-sm-12.col-md-8.offset-md-2.col-lg-8.offset-lg-2.wow.fadeInLeft', [
        h('.contact-info-box.address.clearfix', [
          h('h3', [h('i.fa-fw.fa-map-marker'), 'Address:']),
          h('span', ['10375 Springhill Dr.', h('br'), 'Brecksville, OH 44141']),
        ]),
        h('.contact-info-box.email.clearfix', [
          h('h3', [h('i.fa-fw.fa-envelope'), 'Email:']),
          h('span', [h('a', { href: 'mailto:hello@simplecityllc.com?Hi%Simple%20City!' }, 'hello@simplecityllc.com')]),
        ]),
        h('.contact-info-box.Hours.clearfix', [h('h3', [h('i.fa-fw.fa-clock-o'), 'Hours:']), h('span', Hours)]),
      ]),
    ]),
  ]);

export default Contact;



// WEBPACK FOOTER //
// ./src/components/Sections/Contact/Contact.js